import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ShareDropDownItemButton,
  type ShareDropDownItemButtonProps,
} from '~/components/features/ShareDropDownItemButton'

export type SaveDocumentImageButtonProps = Pick<
  ShareDropDownItemButtonProps,
  'disabled' | 'onClick'
> & {
  'data-testid'?: string
}

export const SaveDocumentImageButton = ({
  'data-testid': dataTestId = 'components-features-save-document-image-button',
  disabled,
  onClick,
}: SaveDocumentImageButtonProps) => {
  const { t } = useTranslation()

  return (
    <ShareDropDownItemButton
      data-testid={dataTestId}
      disabled={disabled}
      label={t('save_tablechart')}
      onClick={onClick}
    />
  )
}
